import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

export default function Footer({ data }) {
  return (
    <>
      <StaticQuery
        query={graphql`
          query MyImage {
            images: sanityImages(name: { eq: "icon" }) {
              id
              image {
                asset {
                  fixed(width: 60) {
                    ...GatsbySanityImageFixed
                  }
                }
              }
            }
          }
        `}
        render={(data) => <Img fixed={data.images.image.asset.fixed} />}
      />
      <a className="footer" href="https://yeshusatsang.org">
        येशु सत्संग
      </a>
    </>
  );
}
